import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
    fetchCompare,
    toggleCompareModal,
    toggleCompareProduct,
    clearCompareProducts,
    toggleProduct,
    getProductCompare,
    setCompareMaxed,
    getConfigCompare,
} from '../compare-actions';

let compareWrapper = Component => props => {
    return <Component {...props} />;
};

const mapStateToProps = (state, ownProps) => {
    const { results, products, modal, errors, resultsV2 } = state.compare;
    const { leftMenu = {} } = state.slugInfo.components;
    const { disableCompare = false } = leftMenu;

    return {
        modalOpen: modal,
        compareProducts: products,
        compareResults: results,
        compareResultsV2: results,
        disableCompare,
        errors,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        fetchCompare: products => dispatch(fetchCompare(products)),
        toggleCompareModal: toggle => dispatch(toggleCompareModal(toggle)),
        toggleCompareProduct: (product, isV2) => dispatch(toggleCompareProduct(product, isV2)),
        clearCompareProducts: () => dispatch(clearCompareProducts()),
        toggleProduct: product => dispatch(toggleProduct(product)),
        getProductCompare: () => dispatch(getProductCompare()),
        closeMaxedError: () => dispatch(setCompareMaxed(false)),
        getConfigCompare: catEntryId => dispatch(getConfigCompare(catEntryId)),
    };
};

const options = {
    pure: false,
};

export default compose(connect(mapStateToProps, mapDispatchToProps), compareWrapper);
